import React from "react";
import { Link } from "react-router-dom";
import footerlogo from "../../assets/images/logo.png";
import { Tooltip, Zoom } from "@mui/material";
function FooterLandingPage() {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div>
      <footer>
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12">
              <div className="footer-logo">
                <img src={footerlogo} height={50} alt="" />
              </div>
              <div className="footer-all-links">
                <div className="footer-menubox">
                  <ul>
                    <li>
                      <Link to="#" onClick={() => scrollToSection("Home")}>
                        Home{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="#" onClick={() => scrollToSection("Features")}>
                        Features
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="Prepp-Community">
                <div className="social">
                  <ul>
                    <li>
                      <Tooltip title="linkedin" TransitionComponent={Zoom} placement="top" arrow>
                        <Link to="https://www.linkedin.com/showcase/selectright-ai/" target="blonk" className="">
                          <i class="lab la-linkedin-in"></i>
                        </Link>
                      </Tooltip>
                    </li>
                    <span>
                      <Link className="mt-2 d-block" to="mailto:sales@ngnext.tech">
                        sales@ngnext.tech
                      </Link>
                    </span>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="bottom-footer">
        <div className="container">
          <div className="row">
            <div className="bottom-footer-box">
              <div className="terms-link">
                <ul>
                  <li>
                    <Link to="/terms">Terms & Conditions</Link>
                  </li>
                  <li>
                    <Link to="/terms">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/terms">Refund Policy</Link>
                  </li>
                </ul>
              </div>
              <div className="terms-link">
                <ul>
                  <li>
                    <a href="https://ngnext.tech/" target="_blank">
                      Copyright @ 2020-2024 NG-NeXT Tech Private Limited, All rights reserved
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default FooterLandingPage;
